module.exports = __webpack_public_path__ + "static/img/行业特性应用2.9a17fef1.png";